<script setup>
import { computed } from 'vue';
import store from '@/store'
import ROUTER from "@/router";

const adminAccess = store.state.user?.otherInfo?.adminAccess;

const hasAccessToThisTab = (nav) => {


  if (!adminAccess.hasFullAccess) {
    return (
      !nav.childAccessId || // No accessId defined = always show
      (nav.childAccessId in adminAccess && adminAccess[nav.childAccessId]) // Must exist AND be true
    )
  }
  return true;
}


/**
 * UI dependencies
 */
import {
  RectangleGroupIcon as RectangleGroupIconOutline,
  BookOpenIcon as BookOpenIconOutline,
  UserGroupIcon as UserGroupIconOutline,
  TrophyIcon as TrophyIconOutline,
  BuildingLibraryIcon as BuildingLibraryIconOutline,
  UserCircleIcon as UserCircleIconOutline,
} from "@heroicons/vue/24/outline";
import {
  RectangleGroupIcon as RectangleGroupIconSolid,
  BookOpenIcon as BookOpenIconSolid,
  UserGroupIcon as UserGroupIconSolid,
  TrophyIcon as TrophyIconSolid,
  BuildingLibraryIcon as BuildingLibraryIconSolid,
  UserCircleIcon as UserCircleIconSolid,
} from "@heroicons/vue/24/solid";

const PAGES = [
  {
    name: "dashboard",
    path: "/v2/dash",
    inactiveIcon: RectangleGroupIconOutline,
    activeIcon: RectangleGroupIconSolid,
    childAccessId: 'v2_landing',
  },
  {
    name: "users",
    path: "/v2/users",
    inactiveIcon: UserGroupIconOutline,
    activeIcon: UserGroupIconSolid,
    childAccessId: 'v2_users',
  },
  {
    name: "materials",
    path: "/v2/materials",
    inactiveIcon: BookOpenIconOutline,
    activeIcon: BookOpenIconSolid,
    childAccessId: 'v2_materials',
  },
  {
    name: "league",
    path: "/v2/league",
    inactiveIcon: TrophyIconOutline,
    activeIcon: TrophyIconSolid,
    childAccessId: 'v2_league',
  },
  // {
  //   name: "academy",
  //   path: "/v2/academy",
  //   inactiveIcon: BuildingLibraryIconOutline,
  //   activeIcon: BuildingLibraryIconSolid,
  // },
  {
    name: "profile",
    path: "/v2/profile",
    inactiveIcon: UserCircleIconOutline,
    activeIcon: UserCircleIconSolid,
  },
];

</script>
<template>
  <footer class="h-footer border-b border-gray-300">
    <ul
      class="
        flex
        w-full
        justify-between
        h-full
        text-xs
        divide-dashed divide-x divide-gray-300
      "
    >
      <li
        v-for="page in PAGES"
        :key="page.name"
        class="w-full flex items-center justify-center"
      >
        <router-link
          @click="ROUTER.currentRoute.value.fullPath = page.path"
          :to="`${page.path}`"
          class="cursor-pointer w-full h-full flex items-center justify-center"
          :class="!hasAccessToThisTab(page) ? 'opacity-10' : ''"
        >
          <component
            :is="
              ROUTER.currentRoute.value.fullPath == page.path
                ? page.activeIcon
                : page.inactiveIcon
            "
            class="h-6 w-6"
            aria-hidden="true"
          />
        </router-link>
      </li>
    </ul>
  </footer>
</template>
<style>
.h-footer{
  min-height: 45pt;
}
</style>